export const FIRST_STEP = 'FIRST_STEP';
export const SECOND_STEP = 'SECOND_STEP';
export const THIRD_STEP = 'THIRD_STEP';
export const FOURTH_STEP = 'FOURTH_STEP';
export const FIFTH_STEP = 'FIFTH_STEP';
export const SIXTH_STEP = 'SIXTH_STEP';
